import { defa } from 'defa-object';
import Zone     from './model-zone';

/**
 * defa.collections.Zones
 * A Collection of Zones
 * @version 1.3.0
 */

const Zones = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: Zone,
	
} );

export default Zones;